import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { routerPaths } from "../../constants/paths"
import { Redirect } from "react-router"

import Alert, { ALERT_MESSAGE } from "../../components/shared/Alert"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import UserList from "../../components/users/UserList"
import LoadingError from "../../components/shared/LoadingError"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import { Header, Segment } from "semantic-ui-react"
import { isFMCUser } from "../../helpers/userRoleHelpers"
import { withTranslation } from "react-i18next"
import AlertModal from "../../components/shared/AlertModal"
import { FMC_USER } from "../../constants/application"
import { isFleetAdvise } from "../../helpers/affiliationHelpers"
import FMCTransactionsShimmer from "./FMCTransactionsShimmer"
import { logFirebaseAnalyticsScreenName } from "../../helpers/googleAnalyticsHelpers"
import { getRouteNameFromUrl } from "../../helpers/segmentHelpers"
import { clearStateAfterTimeout } from "../../helpers/documentHelpers"

class FMCUsers extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoadingError: PropTypes.bool.isRequired,
    users: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)

    const locationStateData = this.props.location.state || {}

    this.state = {
      alertMessage: locationStateData.alertMessage || "",
      alertType: locationStateData.alertType || "default",
      openAlertModal: false,
      userIdToDelete: null
    }
  }

  componentDidMount = () => {
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())

    this.loadUsers()
    this.loadAllFleets()
  }

  loadUsers = async () => {
    await this.props.dispatch({ type: "FMC_USERS_LOAD_SAGA" })
  }

  loadAllFleets = () => {
    this.props.dispatch({
      type: "ALL_FLEETS_LOAD_SAGA"
    })
  }

  onDeleteUser = (userId) => {
    this.setState({ openAlertModal: true, userIdToDelete: userId })
  }

  handleModalState = () => {
    this.setState({ openAlertModal: false })
  }

  onDeleteUserSuccess(data) {
    this.props.history.push({
      state: {
        alertMessage: data.alertMessage,
        alertType: data.alertType
      }
    })
    this.loadUsers()
  }

  afterDeleteUser(status, data) {
    if (status === "success") {
      this.onDeleteUserSuccess(data)
    } else {
      this.onRequestFailure(data)
    }
  }

  onRequestFailure = (data) => {
    this.setState({
      alertMessage: data.alertMessage,
      alertType: data.alertType
    })
  }

  onRequestSuccess(data) {
    this.setState({
      alertMessage: data.alertMessage,
      alertType: data.alertType
    })
  }

  shouldRenderContent() {
    const { isLoading, isLoadingError, users, currentUser } = this.props
    return !isLoading && !isLoadingError && users && currentUser && isFMCUser(currentUser)
  }

  renderContent() {
    const { users, currentUser, t, dispatch, language } = this.props

    if (currentUser && !isFMCUser(currentUser)) {
      // TODO: extract this work to the Router itself.
      return <Redirect to={routerPaths.dashboard} />
    } else if (this.shouldRenderContent()) {
      return (
        <div>
          <span />
          <Header size="small" className={"dash-hd"}>
            {t("usersLabel")}
          </Header>
          <Segment.Group>
            <Segment className="tab-container">
              <UserList
                users={users.filter((user) => isFMCUser(user))}
                onDelete={this.onDeleteUser}
                loadUsers={this.loadUsers}
                currentUser={currentUser}
                isFMC={true}
                dispatch={dispatch}
                language={language}
              />
            </Segment>
          </Segment.Group>
        </div>
      )
    } else {
      return isFleetAdvise() ? <FMCTransactionsShimmer /> : null
    }
  }

  render() {
    const { isLoading, isLoadingError } = this.props

    const { alertMessage, alertType, openAlertModal, userIdToDelete } = this.state

    return (
      <ApplicationLayout>
        {alertMessage && (
          <Alert
            message={alertMessage}
            type={alertType}
            clearStateAfterTimeout={() =>
              clearStateAfterTimeout(this.setState.bind(this), ALERT_MESSAGE)
            }
          />
        )}

        {!isFleetAdvise() ? <LoadingThrobber visible={!this.shouldRenderContent()} /> : null}

        <LoadingError visible={!isLoading && isLoadingError} />

        {this.renderContent()}

        {openAlertModal ? (
          <AlertModal
            openAlertModal={openAlertModal}
            hideModal={this.handleModalState}
            idToDelete={userIdToDelete}
            afterDelete={this.afterDeleteUser}
            that={this}
            modelFrom={FMC_USER}
          />
        ) : null}
      </ApplicationLayout>
    )
  }
} // class Dashboard

const mapStateToProps = (state) => ({
  users: state.users.fmcUsers,
  isLoading: state.application.isLoading,
  isLoadingError: state.application.isLoadingError,
  currentUser: state.application.userSessionData || state.users.currentUser,
  language:
    (state.application.userSessionData && state.application.userSessionData.language) ||
    state.users.currentUser
      ? state.users.currentUser.language
      : ""
})

export default connect(mapStateToProps)(withTranslation("fmcUsers")(FMCUsers))
